<template>
  <div>
    <v-row justify="center">
      <v-dialog class="modal_medium" v-model="visible" persistent>
        <v-card>
          <v-form
            ref="form"
            v-model="valid"
            method="post"
            enctype="multipart/form-data"
            lazy-validation
          >
            <v-card-title>
              <span class="headl">BORRAR PERIODO</span>
            </v-card-title>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="12" md="12">
                    <div class="del_ctn">
                      <p>
                        Está a punto de eliminar el periodo con nombre
                        <b>{{ data.name }}</b
                        >, si la acción es correcta escriba el nombre.
                      </p>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="12" md="12">
                    <v-text-field
                      ref="name"
                      v-model="name"
                      :rules="[nameRules.required, nameRules.equal]"
                      label="Nombre del periodo"
                      required
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <div class="ctn_btn_shop">
                <v-btn large text @click.stop="show = false">Cerrar</v-btn>
                <v-btn
                  class="btn_delete"
                  :disabled="!valid"
                  depressed
                  large
                  @click="validate"
                  >Eliminar</v-btn
                >
              </div>
            </v-card-actions>
          </v-form>
        </v-card>
      </v-dialog>
    </v-row>
  </div>
</template>
<script>
import { mapActions } from 'vuex'
export default {
  name: 'PeriodDeleteComp',
  components: {},
  props: {
    visible: {
      type: Boolean,
    },
    data: {
      type: Object,
    },
  },
  data() {
    return {
      valid: true,
      name: null,
      nameRules: {
        required: (v) => !!v || 'El nombre es requerido',
        equal: (v) => v === this.data.name || 'El nombre no coincide.',
      },
    }
  },
  methods: {
    ...mapActions(['deletePeriod', 'alertSnackbar']),
    validate() {
      if (this.$refs.form.validate()) {
        this.registerForm()
      }
    },
    async registerForm() {
      try {
        let form = {
          _id: this.data._id,
        }
        let deleted = await this.deletePeriod(form)
        this.$refs.form.reset()
        this.show = false
        if (deleted == 200) {
          this.alertSnackbar({
            snackbar: true,
            text: 'El periodo se ha borrado.',
          })
          this.$root.$emit('reload') // parametro update tabla
        } else {
          this.alertSnackbar({
            snackbar: true,
            text: 'ocurrio un error con el servidor.',
          })
        }
      } catch (error) {
        this.alertSnackbar({
          snackbar: true,
          text: 'ocurrio un error inesperado.',
        })
      }
    },
  },
  computed: {
    show: {
      get() {
        return this.visible
      },
      set(value) {
        if (!value) {
          this.$refs.form.reset()
          this.$emit('close')
        }
      },
    },
  },
}
</script>
<style lang="scss">
@import '../../assets/scss/base.scss';
.del_ctn {
  p {
    font-family: Roboto;
    font-size: 1rem;
    margin-bottom: 0;
  }
}
</style>
